import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from 'lucide-react';
import type { CompanyMemberSortDirection } from './company-member-display';

interface CompanyMemberSortHeaderProps {
  active: boolean;
  direction: CompanyMemberSortDirection;
  label: string;
  onClick: () => void;
}

export function CompanyMemberSortHeader({
  active,
  direction,
  label,
  onClick,
}: CompanyMemberSortHeaderProps) {
  const accessibleState = active
    ? `tri ${direction === 'asc' ? 'croissant' : 'décroissant'} actif. Inverser le tri.`
    : 'colonne non triée. Activer le tri.';

  return (
    <button
      aria-label={`${label}, ${accessibleState}`}
      className="inline-flex items-center gap-2 font-medium text-foreground"
      onClick={onClick}
      type="button"
    >
      <span>{label}</span>
      {!active
        ? <ArrowUpDownIcon aria-hidden="true" className="size-3.5" />
        : direction === 'asc'
          ? <ArrowUpIcon aria-hidden="true" className="size-3.5" />
          : <ArrowDownIcon aria-hidden="true" className="size-3.5" />}
    </button>
  );
}
